import { gql } from '@apollo/client';
export const StatFeatureContractedHoursPerDay = gql `
    fragment StatFeatureContractedHoursPerDay on ContractedHoursPerDayFeatureSettingsFlags {
        isEnabled
    }
`;
